import request from '@/utils/request'
// 地址列表
export function addrList(params) {
  return request({
    url: '/member/address/list',
    method: 'get',
    params: params
  })
}
// 添加地址
export function addrAdd(params) {
  return request({
    url: '/member/address/add',
    method: 'post',
    params: params
  })
}
// 修改地址
export function addrUpdate(id, params) {
  return request({
    url: '/member/address/update/' + id,
    method: 'post',
    params: params
  })
}
// 删除地址
export function addrDelete(id) {
  return request({
    url: '/member/address/delete/' + id,
    method: 'post'
  })
}